var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20904 21.4414H2.96631V27.9997H7.20904V21.4414Z",
    fill: "#5C8C36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96631 0V11.777H7.20904V4.24432H20.7913V28H25.0341V0H2.96631Z",
    fill: "#5C8C36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7226 14.6067H2.96631V18.614H9.7226V21.2462L16.1681 16.6104L9.7226 11.9746V14.6067Z",
    fill: "#5C8C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTime);
export default __webpack_public_path__ + "static/media/in_time.15b1bcb0e0cab50fc9cdd29cf735d0f9.svg";
export { ForwardRef as ReactComponent };